import React, { useContext, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import TranslateText from "../../resuableComponents/TranslateText";
import "./paymentButton.css";
import { useDispatch, useSelector } from "react-redux";
import {
  selectActivePaymentMethod,
  selectButtonError,
  selectButtonLoading,
  selectPaymentMethodInfo,
  selectPopWindowIframeUpiIntent,
  toggleButtonError,
} from "../../../slices/PaymentButtonSlice";
import {
  resetErrorMsg,
  selectCurrencyCode,
  selectToatalAmount,
  selectToken,
} from "../../../slices/PaymentSessionDetailsSlice";
import CustomButton from "../../resuableComponents/CustomButton";
import { selectIsMobileLayout } from "../../../slices/MobileLayoutSlice";
import { isEmpty, numberToCurrency, getStorage, updateStorage, handleRoutingOnPaymentStatus, getPopDimensionDetails, isFireFox, iframeLoadingComponent, getNetAmount, getQueryParams } from "../../../Utils/utils";
import {
  handleUpiError,
  intentAppName,
  resetUpiStatus,
  selectShowUpiVpaTimer,
  selectUpiVpa,
  setVpaValidationDetails,
  toggleUpiVpaTimer,
  validUpiId,
} from "../../../slices/UpiSlice";
import { buildPaymentRequest, handleFormatDiscount } from "../../../Utils/paymentUtils";
import {
  initiatePayment,
  resetPaymentInitiation,
  resetPaymentInitiationLoading,
  showFailedModal,
} from "../../../slices/PaymentInitiationSlice";
import { selectSelectedIntrument } from "../../../slices/SavedInstrumentSlice";
import PaymentResponseHandler from "../../../Utils/paymentResponseHandler";
import Loading from "../loadingScreen/Loading";
import {
  cardCvcData,
  cardExpiryDateData,
  cardHolderNameData,
  cardNumberData,
  cardbrandName,
  disableStateOfButton,
  selectIsSaveCardAsPerRbi,
  selectCardNickName,
} from "../../../slices/CardSlice";
import ErrorModal from "../modals/errorModal/ErrorModal";
import { InfoCircleOutlined } from "@ant-design/icons";
import {
  getActiveStatus,
  resetFinalStatusResponse,
} from "../../../slices/finalStatusSlice";
import UpiTimerModal from "../paymentOptions/Upi/UpiTimerModal";
import {
  durationValue,
  emiButton,
  emiCodeValue,
} from "../../../slices/EmiSlice";
import { paymentInitiatedEvent, viewSurchargeEvent, hideSurchargeEvent } from "../../../Utils/uiAnalytics";
import { handleTogglePaymentSummaryFieldOnMobile, handleTotalPaymentSummaryError, handleTotalPaymentSummaryField } from "../../../slices/HandleAdditionalComponentsSlice";
import axiosInstance from "../../../Utils/axiosInstance";
import { getTransactionStatus, selectTransactionData } from "../../../slices/TransactionIdSlice";
import PaymentContext from "../../../context/payment.context";
import { message, notification } from "antd";
import Panel from "antd/es/splitter/Panel";

const PyamentButton = ({ hideButton = false }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { isDccSelected } = useContext(PaymentContext);
  const isIframe = window.self !== window.top;
  const popWindowIframeRef = useRef();
  const iframeWindowStatusInterval = useRef();
  const [isIframePopUpBlocked, setIsIframePopUpBlocked] = useState(false);
  const isMobileLayout = useSelector((state) => selectIsMobileLayout(state));
  const token = useSelector((state) => selectToken(state));
  const buttonError = useSelector((state) => selectButtonError(state));
  const buttonLoading = useSelector((state) => selectButtonLoading(state));
  const currencyCode = useSelector((state) => selectCurrencyCode(state));
  const amount = useSelector((state) => selectToatalAmount(state));
  const paymentSuccessData = useSelector((state) => selectTransactionData(state));
  const selectedInstrument = useSelector((state) => selectSelectedIntrument(state));
  const activePaymentMethod = useSelector((state) => selectActivePaymentMethod(state));
  const buttonDisableState = useSelector((state) => disableStateOfButton(state));
  const upiVpa = useSelector((state) => selectUpiVpa(state));
  const cardNumber = useSelector((state) => cardNumberData(state));
  const cardHolderName = useSelector((state) => cardHolderNameData(state));
  const cardExpiryDate = useSelector((state) => cardExpiryDateData(state));
  const cardCvc = useSelector((state) => cardCvcData(state));
  const latestBrandName = useSelector((state) => cardbrandName(state));
  const selectedTabValue = useSelector((state) => state.emiCardDetails.selectedTabValue);
  const sessionDetails = useSelector((state) => state.paymentSessionDetails.sessionDetails);
  const sessionDetailsStatusReason = useSelector((state) => state.paymentSessionDetails.sessionDetailsStatusReason);
  const sampleToken = useSelector((state) => state.paymentSessionDetails.sampleToken);
  const paymentMethodInfo = useSelector((state) => selectPaymentMethodInfo(state));
  const paymentInitiationData = useSelector((state) => state.paymentInitiation.paymentInitiationData);
  const paymentInitiationError = useSelector((state) => state.paymentInitiation.paymentInitiationError);
  const isPaymentRejectedOrFailed = useSelector((state) => state.paymentInitiation.isPaymentRejectedOrFailed);
  const paymentInitiationLoading = useSelector((state) => state.paymentInitiation.paymentInitiationLoading);
  const failedModal = useSelector((state) => state.paymentInitiation.failedModal);
  const updatedShopperDetails = useSelector((state) => state.paymentSessionDetails.updatedShopperDetails);
  const [validUpiIdData, setValidUpiIdData] = useState();
  const [validUpiIdErrorMessage, setValidUpiIdErrorMessage] = useState();
  const [validUpiIdLoading, setValidUpiIdLoading] = useState();
  const showTotalPaymentSummaryField = useSelector((state) => state.additionalComponents.showTotalPaymentSummaryField);
  const totalPaymentSummaryValue = useSelector((state) => state.additionalComponents.totalPaymentSummaryValue);
  const emiPaymentButton = useSelector((state) => emiButton(state));
  const [showPaymentLoading, setShowPaymentLoading] = useState(false);
  const isAutoRefundLoaderActive = useSelector((state) => !!state.autoRefund.activeTransactionId);
  const intervalRef = useRef(null);
  const showUpiVpaTimer = useSelector((state) => selectShowUpiVpaTimer(state));
  const activeStatusReason = useSelector((state) => state.finalStatus.activeStatusReason);
  const callerType = useSelector((state) => state.paymentSessionDetails.callerType);
  const duration = useSelector((state) => durationValue(state));
  const emiCode = useSelector((state) => emiCodeValue(state));
  const upiIntentName = useSelector((state) => intentAppName(state));
  const transactionId = getStorage("session", "t_id") || getStorage("session", "s_d")?.lastTransactionId;
  const isIphone = useSelector((state) => state.mobileLayout.isIphone);
  const popUpWindowIframeForUpiIntent = useSelector((state) => selectPopWindowIframeUpiIntent(state));
  const isDccQuotationSelected = useSelector((state) => state.cardDetails.isDccQuotationSelected);
  const dccQuotation = useSelector(state => state.cardDetails.dccQuotation);
  const dccMoney = dccQuotation?.dccQuotationDetails?.dccMoney?.amount;
  const issuerCurrencyDetails = useSelector(state => state.cardDetails.issuerCurrencyDetails);
  const appliedOfferDetail = useSelector(state => state.offers.appliedOfferDetail)
  const offerApplyLoader = useSelector(state => state.offers.offerApplyLoader)
  const cardBinData = useSelector((state) => state.binDetails.cardBinData);
  const totalSurchargeAmount = useSelector(state => state.surcharges.totalSurchargeAmount);
  const activeSurchargeDetail = useSelector(state => state.surcharges.activeSurchargeDetail);
  const surchargeCodes = activeSurchargeDetail?.length ? activeSurchargeDetail?.map(el => el.surchargeDetails?.surchargeCode) : []
  const isLoggedIn = useSelector((state) => state.shopperInfo.isLoggedIn);
  const isSaveCardAsPerRbi = useSelector((state) => selectIsSaveCardAsPerRbi(state));
  const cardNickName = useSelector((state) => selectCardNickName(state));
  const surchargeData = useSelector(state => state.surcharges);
  const [isChargeSectionOpen, setIsChargeSectionOpen] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();
  const [showToast, setShowToast] = useState(false);
  const [offsetTop, setOffsetTop] = useState(80);


  useEffect(() => {
    const updatePosition = () => {
      if (window.visualViewport) {
        setOffsetTop(window.visualViewport.offsetTop + 20);
      }
    };

    updatePosition();
    window.visualViewport?.addEventListener('resize', updatePosition);
    window.visualViewport?.addEventListener('scroll', updatePosition);

    return () => {
      window.visualViewport?.removeEventListener('resize', updatePosition);
      window.visualViewport?.removeEventListener('scroll', updatePosition);
    };
  }, []);

  useEffect(() => {
    let showTimer;
    let hideTimer;
    if (activeSurchargeDetail.length > 0) {
      setShowToast(false);
      dispatch(handleTogglePaymentSummaryFieldOnMobile(true));
      showTimer = setTimeout(() => {
        setShowToast(true);
      }, 10);
      hideTimer = setTimeout(() => setShowToast(false), 2000);
    } else {
      setShowToast(false);
    }
    return () => {
      clearTimeout(showTimer);
      clearTimeout(hideTimer);
    };
  }, [surchargeCodes.join(","), activePaymentMethod]);

  useEffect(() => {
    dispatch(resetPaymentInitiation());
    clearInterval(intervalRef.current);
  }, [activePaymentMethod]);
  useEffect(() => {
    if (paymentInitiationData === null) {
      stopStatusCall();
    }
  }, [paymentInitiationData]);

  // UPI -- starts
  // handleQrPay in UpiQr and handleIntentPay in UpiIntent
  const handleUpiValidation = async (payload) => {
    setValidUpiIdLoading(true);
    const baseUrl = process.env.REACT_APP_BASE_URL;
    try {
      const response = await axiosInstance.post(
        `${baseUrl}/platform/vpa-validation`,
        payload
      );
      setValidUpiIdLoading(false);
      setValidUpiIdData(response.data);
      dispatch(setVpaValidationDetails({ data: response.data }));
    } catch (error) {
      setValidUpiIdLoading(false);
      if (error?.response) {
        dispatch(setVpaValidationDetails(error?.response?.data));
        setValidUpiIdErrorMessage(error?.response?.data);
        return error?.response?.data;
      } else {
        dispatch(setVpaValidationDetails(error?.message));
        setValidUpiIdErrorMessage(error?.message);
        return error?.message;
      }
    }
  };
  const handleUpiPay = () => {
    const vpaPayload = {
      vpa: upiVpa,
      legalEntity: sessionDetails?.paymentDetails?.context?.legalEntity?.code,
      merchantId: sessionDetails?.merchantId,
      countryCode: "IN",

    };
    handleUpiValidation(vpaPayload);
    if (isIframe) {
      // setPopupWindowForIframe(true) // hidden popup for UPI validation
    }
  };
  useEffect(() => {
    if (!isEmpty(validUpiIdData)) {
      if (validUpiIdData?.vpaValid === true) {
        let paymentRequest = buildPaymentRequest(
          paymentMethodInfo?.instrumentTypeValue ||
          selectedInstrument?.instrumentTypeValue ||
          "upi/collect",
          updatedShopperDetails,
          sessionDetails,
          "",
          appliedOfferDetail?.codes,
          surchargeCodes
        );
        if (activePaymentMethod === "UpiSaved") {
          paymentRequest.payload.instrumentDetails.upi = {
            shopperVpa: selectedInstrument?.value,
          };
        } else {
          paymentRequest.payload.instrumentDetails.upi = {
            shopperVpa: upiVpa || selectedInstrument?.value,
          };
          if (isLoggedIn) {
            paymentRequest.payload.instrumentDetails['saveInstrument'] = true;
          }
        }
        if (totalPaymentSummaryValue) {
          paymentRequest.payload.money = {
            amount: totalPaymentSummaryValue,
            currencyCode: sessionDetails?.paymentDetails?.money?.currencyCode,
          };
        }
        let token = paymentRequest?.token;
        let payload = paymentRequest?.payload;
        if (showTotalPaymentSummaryField && totalPaymentSummaryValue === "") {
          dispatch(handleTotalPaymentSummaryError("Please enter amount"));
          window.scrollTo({ top: 0, behavior: "smooth" }); // Scroll to the top of the page
        } else {
          dispatch(initiatePayment({ token, payload }));
          paymentInitiatedEvent(
            "Upi",
            paymentMethodInfo?.instrumentTypeValue ||
            selectedInstrument?.instrumentTypeValue ||
            "UpiCollect"
          );
        }
      } else if (validUpiIdData?.vpaValid === false) {
        dispatch(toggleButtonError(true));
        dispatch(handleUpiError("Invalid UPI Id"));
      }
    } else if (!isEmpty(validUpiIdErrorMessage)) {
      let paymentRequest = buildPaymentRequest(
        paymentMethodInfo?.instrumentTypeValue ||
        selectedInstrument?.instrumentTypeValue ||
        "upi/collect",
        updatedShopperDetails,
        sessionDetails,
        "",
        appliedOfferDetail?.codes,
        surchargeCodes
      );
      if (activePaymentMethod === "UpiSaved") {
        paymentRequest.payload.instrumentDetails.upi = {
          shopperVpa: selectedInstrument?.value,
        };
      } else {
        paymentRequest.payload.instrumentDetails.upi = {
          shopperVpa: upiVpa || selectedInstrument?.value,
        };
      }
      if (totalPaymentSummaryValue) {
        paymentRequest.payload.money = {
          amount: totalPaymentSummaryValue,
          currencyCode: sessionDetails?.paymentDetails?.money?.currencyCode,
        };
      }
      let token = paymentRequest?.token;
      let payload = paymentRequest?.payload;
      if (showTotalPaymentSummaryField && totalPaymentSummaryValue === "") {
        dispatch(handleTotalPaymentSummaryError("Please enter amount"));
        window.scrollTo({ top: 0, behavior: "smooth" }); // Scroll to the top of the page
      } else {
        dispatch(initiatePayment({ token, payload }));
        paymentInitiatedEvent(
          "Upi",
          paymentMethodInfo?.instrumentTypeValue ||
          selectedInstrument?.instrumentTypeValue ||
          "UpiCollect"
        );
      }
    }
  }, [validUpiIdData, validUpiIdErrorMessage]);
  const checkIframePopWindowStatus = () => {
    iframeWindowStatusInterval.current = setInterval(() => {
      if (popWindowIframeRef.current?.closed) {
        setShowPaymentLoading(false);
        dispatch(resetPaymentInitiation());
        dispatch(resetPaymentInitiationLoading())
        clearInterval(iframeWindowStatusInterval.current);
      }
    }, 1000);
  }
  const statusPollingTypes = ["Upi", "UpiOneTimeMandate", "Paynow"];
  useEffect(() => {
    if (paymentInitiationData && (statusPollingTypes.includes(paymentInitiationData?.paymentMethod?.type) || isIframe)) {
      // Native OTP owns its own status polling and screen; skip the redirect/iframe
      // handling below, which would otherwise act on a bank-fallback action.
      if (paymentInitiationData?.paymentMethod?.type === "Card" && paymentInitiationData?.actions?.some((action) => action?.type === "nativeOtp")) {
        return;
      }
      let token = sessionDetails?.token;
      const actionType = paymentInitiationData?.actions[0]?.type;

      // this block checks if the pop up window is manually closed by user during pending payment phase.
      if (isIframe && (actionType === 'html' || actionType === 'redirect')) checkIframePopWindowStatus();

      //this checks if the upi collect brand is used to start the upi vpa timer
      if ((paymentInitiationData.paymentMethod?.brand === "UpiCollect" || paymentInitiationData.paymentMethod?.brand === "UpiCollectOtm") && paymentInitiationData.actions[0]?.type !== 'html') {
        dispatch(toggleUpiVpaTimer(true));
      }

      if (isIframe && popWindowIframeRef.current && paymentInitiationData?.actions[0]?.type === 'html') {
        const { width, height, left, top } = getPopDimensionDetails();
        popWindowIframeRef.current.moveTo(left, top); // Change these values as needed
        popWindowIframeRef.current.resizeTo(width, height);
      } else if (paymentInitiationData?.actions[0]?.type !== 'redirect') {
        closeIframePopups();
      }
      intervalRef.current = setInterval(() => {

        dispatch(getTransactionStatus({ token, transactionId }));
        // dispatch(getActiveStatus({ token }));
      }, 4000);
      return () => {
        clearInterval(intervalRef.current);
      };
    }
  }, [paymentInitiationData]);

  const sendDataToSDKFromIframe = (redirectUrl, status) => {
    const returnUrlKeyQueryParams = getQueryParams(sessionDetails?.paymentDetails?.frontendReturnUrl)
    const message = {
      action: 'closeIframe',
      payload: { data: { redirectionResult: getRedirectionResult(redirectUrl), status, } }
    };
    if (!isEmpty(returnUrlKeyQueryParams)) {
      message.payload.data = {
        ...message.payload.data,
        ...returnUrlKeyQueryParams
      }
    }
    window.parent.postMessage(message, '*');
  }

  useEffect(() => {
    // case of test cards where payment is instantly approved
    if (isIframe && (paymentInitiationData?.status === "Approved" || paymentInitiationData?.status?.status === "Approved")) {
      let redirectUrl = paymentInitiationData?.actions[0]?.url;
      sendDataToSDKFromIframe(redirectUrl, 'success');
      closeIframePopups();
    }
  }, [paymentInitiationData]);

  const getRedirectionResult = (redirectUrl) => {
    const parsedUrl = new URL(redirectUrl);
    const params = new URLSearchParams(parsedUrl.search);
    return params.get('redirectionResult');
  }

  const handlePostMessageEventsForIframe = () => {
    if (paymentSuccessData?.status === "FAILED" || paymentSuccessData?.status === "Rejected") {
      stopStatusCall();
      dispatch(showFailedModal(true));
      return
    }
    if (paymentSuccessData?.status === "PAID" || paymentSuccessData?.status === "PROCESSING") {
      let redirectUrl = paymentSuccessData?.actions[0]?.url;
      if (paymentInitiationData?.paymentMethod?.type === "Upi") {
        stopStatusCall();
        sendDataToSDKFromIframe(redirectUrl, 'success');
      } else {
        stopStatusCall();
        sendDataToSDKFromIframe(redirectUrl, 'success');
      }
    } else {
      return
      window.addEventListener('message', (e) => {
        let eventResponse = e?.data?.data;
        if (eventResponse?.redirectionResult) {
          stopStatusCall();
          const message = {
            action: 'closeIframe',
            payload: { data: { ...eventResponse, status: "failed" } }
          };
          window.parent.postMessage(message, '*'); // send the data to sdk from where this iframe is triggered
        } else {

          handleRoutingOnPaymentStatus({
            paymentSuccessData,
            sessionDetails,
            stopStatusCall,
            dispatch,
            showFailedModal
          });
        }
      });
    }
  }
  useEffect(() => {
    if (!paymentSuccessData) return
    if (isIframe) {
      handlePostMessageEventsForIframe();
    } else {
      handleRoutingOnPaymentStatus({
        paymentSuccessData,
        sessionDetails,
        stopStatusCall,
        dispatch,
        showFailedModal
      });
    }
  }, [paymentSuccessData]);

  const closeIframePopups = () => {
    if (isIframe) {
      setShowPaymentLoading(false);
      popWindowIframeRef?.current?.close();
      if (!isEmpty(popUpWindowIframeForUpiIntent)) {
        popUpWindowIframeForUpiIntent?.close();
      }
    }
  }
  const stopStatusCall = () => {
    clearInterval(intervalRef.current);
    closeIframePopups();
    if (paymentInitiationData && (paymentInitiationData?.paymentMethod?.brand === "UpiCollect" || paymentInitiationData?.paymentMethod?.brand === "UpiCollectOtm")) {
      dispatch(toggleUpiVpaTimer(false));
      dispatch(resetPaymentInitiation());
      dispatch(resetUpiStatus());
    }
  };
  const setPopupWindowForIframe = (hidden = false) => {
    const { width, height, left, top } = getPopDimensionDetails();
    let w = hidden ? '10' : width;
    let h = hidden ? '10' : height;
    let topV = hidden ? '10000' : top;
    let leftV = hidden ? '10000' : left;
    popWindowIframeRef.current = window.open('', 'FormPopup', `width=${w},height=${h},top=${topV},left=${leftV},menubar=no`);

    const container = iframeLoadingComponent(popWindowIframeRef.current, `${t("LOADING")}...`);
    popWindowIframeRef.current.document.body.appendChild(container);
  }
  const handleWalletBNPLNetBankingPay = () => {
    let paymentRequest = buildPaymentRequest(
      selectedInstrument?.instrumentTypeValue,
      updatedShopperDetails,
      sessionDetails,
      "",
      appliedOfferDetail?.codes,
      surchargeCodes
    );
    if (totalPaymentSummaryValue) {
      paymentRequest.payload.money = {
        amount: totalPaymentSummaryValue,
        currencyCode: sessionDetails?.paymentDetails?.money?.currencyCode,
      };
    }
    let token = paymentRequest?.token;
    let payload = paymentRequest?.payload;
    if (showTotalPaymentSummaryField && totalPaymentSummaryValue === "") {
      dispatch(handleTotalPaymentSummaryError("Please enter amount"));
      window.scrollTo({ top: 0, behavior: "smooth" }); // Scroll to the top of the page
    } else {
      dispatch(initiatePayment({ token, payload }));
      paymentInitiatedEvent(
        selectedInstrument?.type,
        selectedInstrument?.brand
      );
      if (isIframe) {
        setPopupWindowForIframe()
      }
    }
  };
  const handleCardPay = () => {
    let paymentRequest = buildPaymentRequest(
      "card/meta",
      updatedShopperDetails,
      sessionDetails,
      "",
      appliedOfferDetail?.codes,
      surchargeCodes
    );
    if (sessionDetails?.context?.countryCode === "IN") {
      paymentRequest = buildPaymentRequest(
        "card/meta",
        updatedShopperDetails,
        sessionDetails,
        '',
        appliedOfferDetail?.codes,
        surchargeCodes
      );
      paymentRequest.payload.instrumentDetails.cardMeta = {
        brand: latestBrandName,
      };
      if (totalPaymentSummaryValue) {
        paymentRequest.payload.money = {
          amount: totalPaymentSummaryValue,
          currencyCode: sessionDetails?.paymentDetails?.money?.currencyCode,
        };
      }
    } else {
      const [expiry_month, expiry_year] = cardExpiryDate?.split("/");
      paymentRequest = buildPaymentRequest(
        "card/plain",
        updatedShopperDetails,
        sessionDetails,
        "",
        appliedOfferDetail?.codes,
        surchargeCodes
      );
      paymentRequest.payload.instrumentDetails.card = {
        number: cardNumber,
        expiry: `20${expiry_year}-${expiry_month}`,
        cvc: cardCvc,
        holderName: cardHolderName,
      };
      if (totalPaymentSummaryValue) {
        paymentRequest.payload.money = {
          amount: totalPaymentSummaryValue,
          currencyCode: sessionDetails?.paymentDetails?.money?.currencyCode,
        };
      }
    }

    // saved card code starts
    if (isSaveCardAsPerRbi) {
      paymentRequest.payload.instrumentDetails['saveInstrument'] = true;
      if (cardNickName?.trim() && paymentRequest.payload.instrumentDetails.card) {
        paymentRequest.payload.instrumentDetails.card.nickName = cardNickName.trim();
      }
    }
    if (!isEmpty(selectedInstrument)) {
      delete paymentRequest.payload.instrumentDetails.card;
      paymentRequest.payload.instrumentDetails.type = 'card/token'

      paymentRequest.payload.instrumentDetails.savedCard = {
        instrumentRef: selectedInstrument?.instrumentRef
      }
    }
    // saved card code ends

    let token = paymentRequest?.token;
    let payload = paymentRequest?.payload;

    if (isDccQuotationSelected) payload.dccQuotationId = dccQuotation.dccQuotationId;
    if (showTotalPaymentSummaryField && totalPaymentSummaryValue === "") {
      dispatch(handleTotalPaymentSummaryError("Please enter amount"));
      window.scrollTo({ top: 0, behavior: "smooth" });
    } else {
      updateStorage("session", "remove", "t_id");
      dispatch(initiatePayment({ token, payload }));

      paymentInitiatedEvent("Card", latestBrandName);
    }
    // if (isIframe && (isFireFox || isIphone)) {
    if (isIframe) {
      setPopupWindowForIframe()
    }
  };
  const handleCardlessEmi = () => {
    const paymentRequest = buildPaymentRequest(
      "emi/cardless",
      updatedShopperDetails,
      sessionDetails,

    );
    paymentRequest.payload.instrumentDetails.emi = {
      provider: selectedInstrument?.emiMethod?.cardlessEmiProviderValue,
    };
    if (totalPaymentSummaryValue) {
      paymentRequest.payload.money = {
        amount: totalPaymentSummaryValue,
        currencyCode: sessionDetails?.paymentDetails?.money?.currencyCode,
      };
    }
    if (showTotalPaymentSummaryField && totalPaymentSummaryValue === "") {
      dispatch(handleTotalPaymentSummaryError("Please enter amount"));
      window.scrollTo({ top: 0, behavior: "smooth" }); // Scroll to the top of the page
    } else {
      dispatch(initiatePayment(paymentRequest));
      paymentInitiatedEvent("Emi", "CardlessEMI");
    }
    if (isIframe) {
      setPopupWindowForIframe()
    }
  };
  const handleCardEmi = () => {
    const [expiry_month, expiry_year] = cardExpiryDate?.split("/");
    const paymentRequest = buildPaymentRequest(
      selectedTabValue,
      updatedShopperDetails,
      sessionDetails,
      emiCode,
    );

    paymentRequest.payload.instrumentDetails.card = {
      number: cardNumber,
      expiry: `20${expiry_year}-${expiry_month}`,
      cvc: cardCvc,
      holderName: cardHolderName,
    };
    if (totalPaymentSummaryValue) {
      paymentRequest.payload.money = {
        amount: totalPaymentSummaryValue,
        currencyCode: sessionDetails?.paymentDetails?.money?.currencyCode,
      };
    }
    paymentRequest.payload.instrumentDetails.emi = {
      duration: duration,
    };
    if (showTotalPaymentSummaryField && totalPaymentSummaryValue === "") {
      dispatch(handleTotalPaymentSummaryError("Please enter amount"));
      window.scrollTo({ top: 0, behavior: "smooth" }); // Scroll to the top of the page
    } else {
      dispatch(initiatePayment(paymentRequest));
      paymentInitiatedEvent("Emi", "CreditCardEMI");
    }
    if (isIframe) {
      setPopupWindowForIframe()
    }

  };
  const handleToggleChargeSection = () => {
    if (isChargeSectionOpen) {
      hideSurchargeEvent();
    } else {
      viewSurchargeEvent();
    }
    setIsChargeSectionOpen(!isChargeSectionOpen);
  };

  const handleCallFormatDiscount = (type, callback) => {
    handleFormatDiscount({
      type,
      callback,
      dispatch,
      sessionDetails,
      appliedOfferDetail,
      selectedInstrument,
      cardBinData,
      showTotalPaymentSummaryField,
      totalPaymentSummaryValue,
      selectedInstrument
    });
  }

  const handlePay = () => {
    let handlePayment = activePaymentMethod === "Recommended" ? selectedInstrument?.type : activePaymentMethod;
    localStorage.setItem("previousActivePaymentTab", activePaymentMethod);

    if (handlePayment === "Emi") {
      if (selectedInstrument && selectedInstrument.brand === "CardlessEMI") {
        handleCallFormatDiscount('CardlessEMI', handleCardlessEmi)
        // handleCardlessEmi();
      } else {
        handleCallFormatDiscount('CardEmi', handleCardEmi)
        // handleCardEmi();
      }
    } else {
      switch (handlePayment) {
        case "Upi":
        case "UpiSaved":
          // handleUpiPay();
          handleCallFormatDiscount('Upi', handleUpiPay)
          break;
        case "UpiOneTimeMandate":
          // handleUpiPay();
          handleCallFormatDiscount('UpiOneTimeMandate', handleUpiPay)
          break;
        case "Wallet":
          handleCallFormatDiscount('Wallet', handleWalletBNPLNetBankingPay)
          break;
        case "NetBanking":
          handleCallFormatDiscount('NetBanking', handleWalletBNPLNetBankingPay)
          break;
        case "BuyNowPayLater":
          handleCallFormatDiscount('BuyNowPayLater', handleWalletBNPLNetBankingPay)
          break;
        case "Card":
          handleCallFormatDiscount('Card', handleCardPay)
          break;
        default:
          break;
      }
    }
  };
  useEffect(() => {
    if (paymentInitiationLoading && activePaymentMethod !== "UpiQr" && activePaymentMethod !== "UpiQrOtm"
      && (isIframe && (isFireFox || isIphone) && !paymentInitiationData?.paymentMethod?.brand === 'UpiIntent' && !paymentInitiationData?.paymentMethod?.brand === "UpiIntentOtm")) {
      setShowPaymentLoading(true);
    } else if (isPaymentRejectedOrFailed) {
      setShowPaymentLoading(false);
    } else if (paymentInitiationData && paymentInitiationData?.actions?.length) {
      const hasNativeOtpAction = paymentInitiationData?.paymentMethod?.type === "Card" && paymentInitiationData?.actions?.some((action) => action?.type === "nativeOtp");
      const redirectAction = paymentInitiationData?.actions?.find((action) => action?.url || action?.htmlPageString);
      const redirectUrl = redirectAction?.url;
      const htmlPageString = redirectAction?.htmlPageString;
      if (!hasNativeOtpAction && (redirectUrl || htmlPageString) && window.location.href !== redirectUrl && (paymentInitiationData.paymentMethod?.type !== "Upi" || paymentInitiationData.paymentMethod?.type !== "UpiOneTimeMandate")) {
        setShowPaymentLoading(true);
      } else {
        setShowPaymentLoading(false);
      }
    } else {
      setShowPaymentLoading(false);
    }
  }, [paymentInitiationLoading, isPaymentRejectedOrFailed, activePaymentMethod, paymentInitiationData]);
  useEffect(() => {
    if (!paymentInitiationLoading && paymentInitiationData) {
      if (paymentInitiationData?.status?.status === "Approved") {
        if (callerType === "PAYMENT_LINK") {

          window.location.replace(`/finalStatus`);
        }
      }
    }
  }, [paymentInitiationLoading, paymentInitiationData, callerType, dispatch]);
  useEffect(() => {
    if (isPaymentRejectedOrFailed) {
      closeIframePopups();
      dispatch(showFailedModal(true));
    }
  }, [isPaymentRejectedOrFailed, dispatch]);
  const handleExitButton = () => {
    if (isIframe) {
      const message = {
        action: 'paymentCancelled',
      };
      window.parent.postMessage(message, '*');
    } else {
      const redirectUrl = sessionDetails?.paymentDetails?.frontendBackUrl;
      if (redirectUrl) {
        window.location.href = redirectUrl;
      }
    }
  };
  const clearPnsFromUrl = () => {
    const url = new URL(window.location.href);
    url.searchParams.delete("pns");
    window.history.pushState({}, "", url.toString());
  };

  const isPaymentButtonDisabled = () => {
    let buttonCheck =
      buttonError ||
      !activePaymentMethod ||
      (activePaymentMethod === "Upi" && !upiVpa) ||
      (activePaymentMethod === "UpiOneTimeMandate" && !upiVpa) ||
      (activePaymentMethod === "UpiSaved" && !selectedInstrument) ||
      (activePaymentMethod === "Wallet" && !selectedInstrument) ||
      (activePaymentMethod === "BuyNowPayLater" && !selectedInstrument) ||
      (activePaymentMethod === "NetBanking" && !selectedInstrument) ||
      (activePaymentMethod === "Card" && (!selectedInstrument && buttonDisableState)) ||
      (activePaymentMethod === "Emi" && emiPaymentButton) ||
      (activePaymentMethod === "Recommended" && !selectedInstrument) ||
      (!isEmpty(dccQuotation) && isEmpty(isDccSelected)) ||
      activePaymentMethod === "UpiQr" || activePaymentMethod === "UpiQrOtm";
    return buttonCheck;
  };
  const getAmount = (isDcc) => getNetAmount({
    isDcc, activePaymentMethod, selectedInstrument, dccMoney, amount, showTotalPaymentSummaryField, totalPaymentSummaryValue, offerAmount: appliedOfferDetail?.finalAmount,
    surchargeAmount: totalSurchargeAmount
  });

  const ExtraChargeMessage = ({ data }) => {
    let firstCharge = data[0];
    let { fee } = firstCharge?.surchargeDetails;
    // let message = `Total includes a ${fee.type === 'Flat' ? `${currencyCode} ${fee.amount} flat` : `${fee.percentage}%`} ${firstCharge?.surchargeDetails?.title}`;
    // let message = `Total includes a ${currencyCode} ${firstCharge?.calculatedSurchargeFee} ${firstCharge?.surchargeDetails?.title}`;
    let message = `A ${currencyCode} ${firstCharge?.calculatedSurchargeFee} ${firstCharge?.surchargeDetails?.title} will be applied`;
    let newMsz = data.length > 1 ? `Additional charges applied` : message
    return (
      <span style={{ color: '#403e9f', fontWeight: 500 }}>{newMsz}</span>
    )
  }

  return (
    <div id="payment-btn-main-class" className={isMobileLayout ? "domestic-mbtn-root" : ""}>
      {/* {contextHolder} */}
      {showToast && (
        <div className="custom-toast" style={{ top: `${offsetTop}px` }}>
          Additional charges applied
        </div>
      )}
      <UpiTimerModal
        upiId={selectedInstrument?.value || upiVpa}
        showTimer={showUpiVpaTimer}
        callback={stopStatusCall}
      />
      {
        isMobileLayout && sessionDetails?.merchantDetails?.convenienceFeeChargedToShopper && (
          <div className="convenience-fee-msz">
            <TranslateText label={"CONVENIENCE_FEE_MSZ"}>
              A convenience fee may be charged while completing your payment
            </TranslateText>
          </div>
        )
      }

      {!hideButton && !isEmpty(activeSurchargeDetail) && (
        <>
          <div className="extra-charges-details">
            <div className={`content ${isChargeSectionOpen ? "open" : ""}`} >
              <div className="inner">
                {activeSurchargeDetail.map((activeSurcharge) => (
                  <div
                    className="charge-row"
                    key={activeSurcharge?.surchargeDetails?.title}
                  >
                    <div className="charge-title">
                      {activeSurcharge?.surchargeDetails?.title}
                    </div>
                    <div className="charge-value">
                      {currencyCode} {activeSurcharge?.calculatedSurchargeFee}
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className={`content ${!isChargeSectionOpen ? "open" : ""}`} style={{ justifyContent: activeSurchargeDetail.length > 1 ? 'space-between' : 'center' }}>
              <ExtraChargeMessage data={activeSurchargeDetail} />
              {
                activeSurchargeDetail?.length > 1 && (
                  <div className="view-more-div"            >
                    <span className="view-more-inner" onClick={handleToggleChargeSection} style={{ color: sessionDetails?.merchantDetails?.checkoutTheme.headerColor }}>
                      {isChargeSectionOpen ? "Hide details" : "View details"}
                    </span>
                  </div>
                )
              }
            </div>

            {
              activeSurchargeDetail?.length > 1 && isChargeSectionOpen && (
                <div className="view-more-div"            >
                  <span className="view-more-inner" onClick={handleToggleChargeSection} style={{ color: sessionDetails?.merchantDetails?.checkoutTheme.headerColor }}>
                    Hide details
                  </span>
                </div>
              )
            }

            {/* Toggle button at bottom */}

          </div>
        </>
      )}
      {!hideButton && (
        <CustomButton
          applyThemeFontSize={true}
          text={
            <div className={`dynamic-font-family ${isPaymentButtonDisabled() ? '' : 'dynamic-button-text'}`}
              style={{ color: isPaymentButtonDisabled() ? 'inherit !important' : sessionDetails?.merchantDetails?.checkoutTheme?.buttonTextColor }}
            >
              <TranslateText label={"PAY"}>Pay </TranslateText>
              {
                isDccQuotationSelected ? (
                  <>
                    <span className="currency-symbol"> {issuerCurrencyDetails.currencyCode}  </span>
                    {numberToCurrency(getAmount(isDccQuotationSelected), issuerCurrencyDetails.currencyCode)}
                  </>
                ) : (
                  <>
                    <span className="currency-symbol"> {currencyCode}  </span>
                    {numberToCurrency(getAmount(), currencyCode)}
                    {/* {showTotalPaymentSummaryField ? totalPaymentSummaryValue : numberToCurrency(getAmount(), currencyCode)} */}
                  </>
                )
              }
            </div>
          }
          buttonType={"primary-btn"}
          block={true}
          loading={
            (!isPaymentButtonDisabled() && offerApplyLoader) ||
            buttonLoading ||
            paymentInitiationLoading ||
            validUpiIdLoading ||
            showPaymentLoading
          }
          disabled={isPaymentButtonDisabled()}
          onClick={handlePay}
        />
      )}
      {/* the auto refund loader takes over the loading screen while it verifies the payment */}
      {showPaymentLoading === true && !isAutoRefundLoaderActive && (
        <Loading
          text={t("PLEASE_WAIT_PROCESSING_PAYMENT")}
          subText={t("NOTE_AVOID_BACK_BUTTON")}
          redirectionName={
            (activePaymentMethod === "Upi" || activePaymentMethod === "UpiOneTimeMandate")
              ? paymentInitiationData?.paymentMethod?.subBrand
              : paymentInitiationData?.paymentMethod?.brand
          }
        />
      )}

      {!isEmpty(paymentInitiationData) && <PaymentResponseHandler isIframe={isIframe} popWindowIframeRef={popWindowIframeRef} stopStatusCall={stopStatusCall} />}
      {(sampleToken || isIframePopUpBlocked) ? (
        <ErrorModal
          icon={
            <InfoCircleOutlined style={{ color: "#FF4D4F", fontSize: "22px" }} />
          }
          title={!isIframePopUpBlocked ? t("PAYMENT_FAILED") : t("POPUP_BLOCKED")}
          desc={!isIframePopUpBlocked ? t("SAMPLE_CHECKOUT_NOTICE") : t('UNBLOCK_POPUP')}
          showModal={failedModal || isIframePopUpBlocked}
          primaryOnClick={() => {
            dispatch(resetPaymentInitiation());
            dispatch(showFailedModal(false));
          }}
          primaryBtnText={!isIframePopUpBlocked ? t("CANCEL") : t("OK")}
        />
      ) : (
        <>
          {/* <ErrorModal
            icon={
              <InfoCircleOutlined style={{ color: "#FF4D4F", fontSize: "22px" }} />
            }
            title={t("PAYMENT_FAILED")}
            desc={(() => {
              const baseMessage = `${t("PAYMENT_RETRY_NOTICE")}.`;
              let errorMessage = "";
              if (paymentInitiationError) {
                errorMessage = paymentInitiationError;
              } else if (paymentSuccessData?.status === "FAILED" && paymentSuccessData?.reasonCode?.startsWith("UF")) {
                errorMessage = activeStatusReason;
              } else if (paymentInitiationData?.paymentMethod?.brand === "UpiIntent") {
                return (
                  <div>
                    <TranslateText label={"PAYMENT_FAILED_WITH"}>Payment failed with</TranslateText> {upiIntentName}. <TranslateText label={"RETRY_PAYMENT_WITH"}>Please retry payment with</TranslateText> <TranslateText label={"DIFFERENT_UPI_APP"}>a different UPI app</TranslateText>
                  </div>
                );
              }

              return (
                <div>
                  {baseMessage}
                  {errorMessage && (
                    <>
                      <br />
                      <br />
                      <b><TranslateText label={"ERROR_MSG"}>Error Msg</TranslateText>: </b>
                      {errorMessage}
                    </>
                  )}
                </div>
              );
            })()}
            showModal={failedModal}
            primaryOnClick={() => {
              clearPnsFromUrl();
              dispatch(resetTransactionStatus());
              dispatch(resetPaymentInitiation());
              dispatch(showFailedModal(false));
              dispatch(resetFinalStatusResponse());
              dispatch(resetUpiStatus());
              dispatch(resetErrorMsg());
            }}
            secondaryOnClick={() => handleExitButton()}
            primaryBtnText={t("RETRY")}
            secondaryBtnText={t("CANCEL")}
            showSecondaryButton={callerType === "CHECKOUT" && true}
          /> */}
        </>
      )}
    </div>
  );
};

export default PyamentButton;



